import React, { FC, useContext } from 'react'

import MaxWidth from '../../layout/MaxWidth/MaxWidth'
import { SectionContext } from '../../../contexts/sectionProvider'
import Banner from '../../common/Banner/Banner'
import QuizModal from '../../modals/QuizModal'
import QuizProvider from '../../../contexts/quizProvider'
import QuizHeader from '../../quiz/QuizHeader/QuizHeader'
import QuizQuestion from '../../quiz/QuizQuestions/QuizQuestion'
import List from './List'

const Section: FC = () => {
  const {
    section,
    sectionCode,
    elements,
    count,
    hasNextPage,
    loading,
    error,
    loadMore,
    isQuizOpen,
    setIsQuizOpen,
    setOrder,
    order,
    sortUpdate,
    refetching,
  } = useContext(SectionContext)

  if (error) {
    return <div>error!</div>
  }

  return (
    <MaxWidth>
      <List
        count={count}
        name={section?.name}
        order={order}
        setOrder={setOrder}
        elements={elements}
        loading={loading}
        sectionCode={sectionCode}
        setIsQuizOpen={setIsQuizOpen}
        hasNextPage={hasNextPage}
        loadMore={loadMore}
        sortUpdate={sortUpdate}
        refetching={refetching}
      />

      <Banner />

      {sectionCode === 'mineralnaya_kosmetika_dlya_litsa' && (
        <QuizProvider>
          <QuizModal open={isQuizOpen}>
            <MaxWidth>
              <QuizHeader closeHandler={setIsQuizOpen} />
            </MaxWidth>
            <QuizQuestion setIsQuizOpen={setIsQuizOpen} />
          </QuizModal>
        </QuizProvider>
      )}
    </MaxWidth>
  )
}

export default Section
